import { useGetAllInventoryReportQuery } from "@states/report/report.api";
import { TSuccessResponse } from "@type-defs/general/TSuccessResponse";

const useGetAllInventoryReport = (args: {
  page?: number;
  limit?: number;
  search?: number | string;
  from_date?: string;
  to_date?: string;
}) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = useGetAllInventoryReportQuery({ ...args });

  const inventoryReportResponse = rawData as any as TSuccessResponse<any>;

  return {
    inventoryReportData: inventoryReportResponse?.data,
    inventoryReportMessage: inventoryReportResponse?.message,
    inventoryReportSuccess: inventoryReportResponse?.success,
    inventoryReportPaginator: inventoryReportResponse?.paginator,
    inventoryReportError: error,
    inventoryReportLoading: isLoading,
    inventoryReportRefetch: refetch,
    inventoryReportFetching: isFetching,
  };
};

export default useGetAllInventoryReport;
